import { AxiosRequestConfig, AxiosResponse } from "axios";

export const API_PATHS = {
  STAKING_POOLS: "/staking/pools",

  NFT_STAKING_POOL: "/nft-staking/pools/{type}",

  NFT_UPGRADE_INFO: "/nft-upgrade/info",
  LEADERBOARD: "/leaderboard/{timeFrame}",

  AUTH_TOKEN: "/auth/token",
  AUTH_LOGIN: "/auth/login",

  MEME_CREATE: "/meme/create",
  MEME_VOTE: "/meme/vote",
  MEME_VOTES_ALL: "/meme/{nonce}/votes-all",
  MEMES_VOTES_ALL: "/memes/votes-all",
  MEME_VOTES_PERIOD: "/meme/{nonce}/votes/{period}",
  MEMES_VOTES_PERIOD: "/memes/votes/{period}",
  MEMES_RESTRICTED: "/memes/restricted",

  MEME_RARITY: "/meme/{nonce}/rarity",
  MEMES_RARITY: "/memes/rarity",

  MEME_TOP_MEME: "/meme/{nonce}/top-meme",
  MEMES_TOP_MEME: "/memes/top-meme",

  CURRENT_PERIOD: "/current-period",
  ADDRESS_LAST_MEME_TIME: "/address-last-meme-time/{address}",
  PERIODS: "/periods",
  ADDRESS_VOTES: "/address-votes/{address}",
};

// The backend microservice that used to serve these endpoints has been decommissioned and is no
// longer reachable (it now returns CORS-blocked errors). Rather than let every caller attempt and
// fail a network request, `get`/`post` reject immediately so failures are fast, silent (no CORS
// console noise) and consistent. Every call site already treats a rejection as "feature
// unavailable" and falls back to a safe default.
class Api {
  async get<T = any>(
    _url: string,
    _params: { [key: string]: any } = {},
    _queryParams: { [key: string]: any } = {}
  ): Promise<AxiosResponse<T>> {
    return Promise.reject(new Error("Backend service is no longer available"));
  }

  async post(_url: string, _data: { [key: string]: any } = {}, _config: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return Promise.reject(new Error("Backend service is no longer available"));
  }
}

const api = new Api();

export default api;
